import { Component, Input } from '@angular/core';
import { BaseListHeaderComponent } from '../../../list/BaseListHeader.component';

@Component({
    selector: 'admin-actimove-list-header',
    templateUrl: 'ActimoveListHeader.component.html'
})
export class ActimoveListHeaderComponent<I> extends BaseListHeaderComponent<I> {
    @Input()
    useSegment = true;
}
